import { render } from "./SelectOptionsModules.vue?vue&type=template&id=142a9b09"
import script from "./SelectOptionsModules.vue?vue&type=script&lang=js"
export * from "./SelectOptionsModules.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Sistema\\Nueva carpeta\\erp-front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__